/**
 * Skip-to-main-content link — WAI-ARIA APG canonical pattern for keyboard
 * users. Visually hidden until focused; on focus, pops into the top-left as
 * a jump link to `#main-content`. Every layout (desktop, mobile)
 * must include this as the FIRST focusable element so tab-key users can bypass
 * the nav on every page load.
 *
 * Companion contract: the layout's landmark `<main>` MUST carry
 * `id="main-content"` and `tabIndex={-1}` so the anchor lands and focus moves.
 * Without both, the link is a no-op.
 *
 * MA-314 (2026-08-05) — extracted from the desktop tier of `Layout.tsx` so
 * every layout shares the same accessibility surface. Styling
 * matches the design system's focus-ring recipe (bg-primary, primary-foreground,
 * shadow) — no drift.
 */
export function SkipToMainContent(): JSX.Element {
  return (
    <a
      href="#main-content"
      data-testid="skip-to-main"
      className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-50 focus:rounded focus:bg-primary focus:px-3 focus:py-1.5 focus:text-xs focus:font-semibold focus:text-primary-foreground focus:shadow"
    >
      Skip to main content
    </a>
  );
}
